if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();

      var _this = this;
      this.isThumbnails = false;

      // swiper container
      this.swiperContainer = this.querySelector(".swiper-container");
      this.config = this.swiperContainer?.dataset || {};

      // Check thumbnails available or not
      if (this.config.thumbs) {
        this.isThumbnails = true;
      }

      // wait for swiper slider
      this.waitForSwiper(function () {
        // If thumbnails available
        _this.initSwiperWithThumbs(_this.swiperContainer);
      });
    }

    // Wit for swiper slider
    waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof Swiper !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    // Thumbnail configuration
    thumbConfig(thumbConfig) {
      var config = {
        slidesPerView: 3,
        spaceBetween: 12,
        loop: true,
        autoplay: false,
        direction: "horizontal",
      };
      // Loop
      if (thumbConfig?.loop) {
        config.loop = thumbConfig.loop;
      }
      // Slide per view
      if (thumbConfig?.slidesPerView > 1) {
        config.slidesPerView = thumbConfig.slidesPerView;
      }

    //autoplay
      if (thumbConfig.autoplay) {
        config.autoplay = {
          delay: thumbConfig.delay || 4000,
        };

        if (!thumbConfig.disableOnInteraction) {
          config.autoplay.disableOnInteraction = thumbConfig.disableOnInteraction;
        }
      }

      // direction
      if (thumbConfig.direction) {
        config.direction = thumbConfig.direction;
      }

      // Breakpoints
      if (thumbConfig.breakpoints) {
        config.breakpoints = JSON.parse(thumbConfig.breakpoints);
      }

      return config;
    }

    // Gallery slider configuration
    galleryConfiguration(galleryConfig, thumbs) {
      var config = {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        direction: "horizontal",
        autoplay: false,
        thumbs: {},
        pagination: {
          el: "",
          clickable: true,
        },
        navigation: {
          nextEl: "",
          prevEl: "",
        },
        on: {
          slideChange: function () {
            if(galleryConfig.pauseVideoOnChange){
              document.querySelectorAll(".custPuraVidaVideoWrapper video").forEach(function (video) {
                video.pause();
              });
            }
          },
        },
      };

      // Pagination
      if (galleryConfig.dots) {
        config.pagination.el = galleryConfig.pagination;
      }
      
      // loop
      if (galleryConfig.loop) {
        config.pagination.el = galleryConfig.loop;
      }
      
      // If prev/next element
      if (galleryConfig?.nav) {
        config.navigation.prevEl = galleryConfig.prevEl;
        config.navigation.nextEl = galleryConfig.nextEl;
      }

      // direction
      if (galleryConfig.direction) {
        config.direction = galleryConfig.direction;
      }

      // per view
      if (galleryConfig?.slidesPerView > 1) {
        config.slidesPerView = thumbConfig.slidesPerView;
      }

      // if thumbs
      if (thumbs) {
        config.thumbs.swiper = thumbs;
      }

      //autoplay
      if (galleryConfig.autoplay) {
        config.autoplay = {
          delay: galleryConfig.delay || 4000,
        };

        if (!galleryConfig.disableOnInteraction) {
          config.autoplay.disableOnInteraction = galleryConfig.disableOnInteraction;
        }
      }

      // Breakpoints
      if (galleryConfig.breakpoints) {
        config.breakpoints = JSON.parse(galleryConfig.breakpoints);
      }

      return config;
    }

    // Initlize swiper slider with thums
    initSwiperWithThumbs() {
      // Thumbnails
      var sliderThumbs = document.querySelector(`${this.config["thumbsId"]}`);

      // Thumbnails initialize
      var thumbs;
      if (sliderThumbs) {
        var thumbConfig = sliderThumbs.dataset;
        thumbConfig = this.thumbConfig(thumbConfig);
        // Thumbnails
        thumbs = new Swiper(sliderThumbs, thumbConfig);
      }

      if (this.swiperContainer) {
        var galleryConfig = this.galleryConfiguration(this.config, thumbs);


        new Swiper(this.swiperContainer, galleryConfig);
      }
    }
  }

  customElements.define("swiper-slider", SwiperSlider);
}
